/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_apex_how_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Predictions are powered by each driver’s recent race results, qualifying pace, and track characteristics. The model weighs recent form more heavily, so a driver on a hot streak will be ranked higher.`)
};

const es_f1_apex_how_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las predicciones se basan en los resultados recientes de carrera, el ritmo en clasificación y las características de la pista de cada piloto. El modelo da más peso a la forma reciente, por lo que un piloto en racha será clasificado más alto.`)
};

const de_f1_apex_how_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Vorhersagen basieren auf den letzten Rennergebnissen, der Qualifikationsleistung und den Streckeneigenschaften jedes Fahrers. Das Modell gewichtet die aktuelle Form stärker, sodass ein Fahrer in Hochform höher eingestuft wird.`)
};

const nl_f1_apex_how_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De voorspellingen zijn gebaseerd op de recente raceresultaten, het kwalificatietempo en de baankenmerken van elke coureur. Het model weegt recente vorm zwaarder, zodat een coureur in topvorm hoger wordt gerangschikt.`)
};

const fr_f1_apex_how_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les prédictions s’appuient sur les résultats récents, le rythme en qualification et les caractéristiques du circuit de chaque pilote. Le modèle accorde plus de poids à la forme récente, donc un pilote en pleine forme sera classé plus haut.`)
};

const it_f1_apex_how_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le previsioni si basano sui risultati recenti, sul ritmo in qualifica e sulle caratteristiche del circuito di ogni pilota. Il modello dà più peso alla forma recente, quindi un pilota in serie positiva sarà classificato più in alto.`)
};

const pt_br2_f1_apex_how_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As previsões são baseadas nos resultados recentes de corrida, ritmo de classificação e características da pista de cada piloto. O modelo dá mais peso à forma recente, então um piloto em boa fase será classificado mais alto.`)
};

const pt_f1_apex_how_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As previsões baseiam-se nos resultados recentes, no ritmo de qualificação e nas características do circuito de cada piloto. O modelo dá mais peso à forma recente, por isso um piloto em boa fase será classificado mais alto.`)
};

const ja_f1_apex_how_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`予測は各ドライバーの最近のレース結果、予選ペース、サーキット特性に基づいています。モデルは最近の調子をより重視するため、好調なドライバーはより高くランク付けされます。`)
};

const zh_f1_apex_how_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预测基于每位车手的近期比赛成绩、排位赛速度和赛道特性。模型更加重视近期状态，因此处于连胜状态的车手排名会更高。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_apex_how_p2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_apex_how_p2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_apex_how_p2", locale)
	if (locale === "en") return en_f1_apex_how_p2(inputs)
	if (locale === "es") return es_f1_apex_how_p2(inputs)
	if (locale === "de") return de_f1_apex_how_p2(inputs)
	if (locale === "nl") return nl_f1_apex_how_p2(inputs)
	if (locale === "fr") return fr_f1_apex_how_p2(inputs)
	if (locale === "it") return it_f1_apex_how_p2(inputs)
	if (locale === "pt-BR") return pt_br2_f1_apex_how_p2(inputs)
	if (locale === "pt") return pt_f1_apex_how_p2(inputs)
	if (locale === "ja") return ja_f1_apex_how_p2(inputs)
	return zh_f1_apex_how_p2(inputs)
};